module.exports = __webpack_public_path__ + "static/media/file.a9dbb417.svg";